import { Example, markers } from '../../../model/common';
import { DeveloperType } from '../../../model/skill';

export function validateAsAdmin(isAdmin: boolean, developerType: DeveloperType) {
    return isAdmin || developerType === DeveloperType.Yandex;
}

export const buildStructuredExamples = (examples: Example[], name: string, phrases: string[]) => {
    return examples.map((value) => {
        if ([name, ...phrases].includes(value.activationPhrase)) {
            return value;
        }

        const hasRequest = markers
            .filter((marker) => marker.hasRequest)
            .map(({ text }) => text)
            .includes(value.request);

        const newValue: Example = {
            ...value,
            activationPhrase: '',
            request: hasRequest ? value.request : '',
        };

        return newValue;
    });
};
